// extracted by mini-css-extract-plugin
module.exports = {"subsection":"style__subsection__oGddl"};